import { connect } from 'react-redux'
import NarrowLayout from './NarrowLayout'

const mapStateToProps = (state, ownProps) => ({
	pageIsOpen: state.currentPage.length > 0
})

export default connect(mapStateToProps)(NarrowLayout);


// WEBPACK FOOTER //
// ./src/components/Layout/NarrowLayoutContainer.js